<div class="mt-channel-window">
  <div class="mt-channel-window-header">
    <div *ngIf="username" class="username"> {{username}} </div>
    <div *ngIf="isSomeoneTyping" class="typing-indicator">is typing...</div>
    <div *ngIf="liveChannel.channelStatus == 'Started'" class="mt-channel-ttl"> {{displayTtl}} </div>
    <div *ngIf="liveChannel.channelStatus == 'Started' && videochatflag ==1" class="mt-icon-video" (click)="openVideoChat()">
      <mitter-video-icon></mitter-video-icon>
    </div>
  </div>

  <div class="mt-channel-window-content" #channelContent>
    <div *ngFor="let channelWindowElement of channelWindowElements" #channelMessages>
      <mitter-message
        *ngIf="isMessage(channelWindowElement)"
        [message]="channelWindowElement"
        [galleryOptions]="galleryOptions"
        [galleryImages]="galleryImages"
      >
      </mitter-message>
      <mitter-channel-event
        *ngIf="!isMessage(channelWindowElement)"
        [channelEvent]="channelWindowElement"
      >
      </mitter-channel-event>
    </div>
  </div>

  <div class="mt-channel-window-footer" *ngIf="liveChannel.channelStatus == 'Started' || userRole === 'DOCTOR'">
    <mitter-chat-input [userRole]="userRole" [mitter]="mitter" [channel]="channel">
    </mitter-chat-input>
  </div>
</div>
